import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaStream, FaSwatchbook } from 'react-icons/fa';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import countrie from '../countrie/countrie';

const Url = process.env.REACT_APP_URL_DEV;
const siteKey = '6LcJm6QrAAAAABClCY7MpfQvSGhxxy0n1MCUjH_R';

const App = () => {
  const [formData, setFormData] = useState({
    civilite: '',
    prenom: '',
    nom: '',
    telephone: '',
    email: '',
    postOccupe: '',
    organisme: '',
    pays: '',
    modeFormation: '',
    theme: '',
    dateDebut: '',
    dateFin: '',
    lieu: '',
    nombrePersonnes: '',
    message: '',
  });

  const [errors, setErrors] = useState({});
  const [captchaToken, setCaptchaToken] = useState('');
  const recaptchaWidgetId = useRef(null);

  const onCaptchaChange = (token) => {
    setCaptchaToken(token);
    setErrors((prev) => ({ ...prev, captcha: '' }));
  };

  useEffect(() => {
    const loadRecaptcha = () => {
      if (window.grecaptcha && window.grecaptcha.render) {
        recaptchaWidgetId.current = window.grecaptcha.render(
          'recaptcha-container',
          {
            sitekey: siteKey,
            callback: onCaptchaChange,
          },
        );
      }
    };

    if (!window.grecaptcha) {
      const script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      script.onload = loadRecaptcha;
      document.body.appendChild(script);
    } else {
      loadRecaptcha();
    }
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.civilite) newErrors.civilite = 'La civilité est requise.';
    if (!formData.prenom) newErrors.prenom = 'Le prénom est requis.';
    if (!formData.nom) newErrors.nom = 'Le nom est requis.';
    if (!formData.telephone)
      newErrors.telephone = 'Le numéro de téléphone est requis.';
    if (!formData.email) newErrors.email = "L'email est requis.";
    if (!formData.postOccupe) newErrors.postOccupe = 'Le poste est requis.';
    if (!formData.organisme) newErrors.organisme = "L'organisme est requis.";
    if (!formData.pays) newErrors.pays = 'Le pays est requis.';
    if (!formData.modeFormation)
      newErrors.modeFormation = 'Le mode de formation est requis.';
    if (!formData.theme) newErrors.theme = 'Le thème est requis.';
    if (!formData.dateDebut)
      newErrors.dateDebut = 'La date de début est requise.';
    if (!formData.dateFin) newErrors.dateFin = 'La date de fin est requise.';
    if (!formData.lieu) newErrors.lieu = 'Le lieu est requis.';
    if (!formData.nombrePersonnes)
      newErrors.nombrePersonnes = 'Le nombre de personnes est requis.';
    if (!captchaToken) newErrors.captcha = 'Veuillez valider le CAPTCHA.';
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      try {
        await axios.post(`${Url}/api/form/Mesure`, {
          ...formData,
          token: captchaToken,
        });

        alert('Formulaire envoyé !');

        setFormData({
          civilite: '',
          prenom: '',
          nom: '',
          telephone: '',
          email: '',
          postOccupe: '',
          organisme: '',
          pays: '',
          modeFormation: '',
          theme: '',
          dateDebut: '',
          dateFin: '',
          lieu: '',
          nombrePersonnes: '',
          message: '',
        });
        setErrors({});
        setCaptchaToken('');
        if (window.grecaptcha && recaptchaWidgetId.current !== null) {
          window.grecaptcha.reset(recaptchaWidgetId.current);
        }
      } catch (error) {
        alert('Une erreur est survenue, veuillez réessayer.');
      }
    }
  };

  return (
    <div className="container6">
      <div className="left-section">
        <div className="icon-container">
          <FaStream className="icon" />
          <h3>Présentation</h3>
        </div>
        <p>
          EXIFOD propose des formations sur mesure, conçues pour répondre aux
          besoins spécifiques de votre organisation et de vos équipes. Chaque
          programme est personnalisé afin de correspondre parfaitement à vos
          objectifs et à votre contexte professionnel. Avec une formation sur
          mesure, vous bénéficiez d’un parcours unique et ciblé, combinant
          contenus spécialisés et méthodes pédagogiques variées, pour un
          apprentissage efficace, concret et directement exploitable. Cette
          approche permet à votre entreprise de renforcer ses compétences tout
          en maximisant l’impact de la formation
        </p>
        <div className="icon-container">
          <FaSwatchbook className="icon1" />
          <h3>Processus de mise en œuvre</h3>
        </div>
        <ul>
          <li>
            <strong>Expression de votre besoin :</strong> Prise de contact avec
            EXIFOD et formalisation de votre demande.
          </li>
          <li>
            <strong>Analyse et échanges : </strong> Nos experts définissent vos
            objectifs et attentes pour construire un programme adapté.
          </li>
          <li>
            <strong>Proposition personnalisée : </strong> Réception de notre
            offre pédagogique et financière.
          </li>
          <li>
            <strong>Animation de la formation :</strong> Session dispensée dans
            vos locaux ou au lieu choisi.
          </li>
        </ul>
        <div className="icon-container">
          <FaStream className="icon2" />
          <h3>Avantages clés</h3>
        </div>
        <ul>
          <li>
            Lieu flexible : La formation se déroule là où vous le souhaitez,
            pour un confort et une disponibilité optimale.
          </li>
          <li>
            Programme personnalisé : Contenus adaptés aux besoins et aux
            spécificités de votre organisation.
          </li>
          <li>
            Durée et organisation modulables : Sessions adaptées à votre
            calendrier, votre rythme et votre identité d’entreprise.
          </li>
          <li>
            <li>
              Durée et organisation modulables : Sessions adaptées à votre
              calendrier, votre rythme et votre identité d’entreprise.
            </li>
          </li>
        </ul>
      </div>
      <div className="right-section">
        <h2>Inscription sur mesure</h2>

        <form onSubmit={handleSubmit}>
          {/* Civilité */}
          <div className="form-row1">
            <div className="form-group1">
              <label>Civilité *</label>
              <select
                name="civilite"
                value={formData.civilite}
                onChange={handleChange}
              >
                <option value="">Civilité</option>
                <option value="M.">M.</option>
                <option value="Mme">Mme</option>
              </select>
              {errors.civilite && <p className="error">{errors.civilite}</p>}
            </div>
            <div className="form-group1">
              <label>Prénom *</label>
              <input
                type="text"
                name="prenom"
                placeholder="Votre prénom"
                value={formData.prenom}
                onChange={handleChange}
              />
              {errors.prenom && <p className="error">{errors.prenom}</p>}
            </div>
          </div>

          {/* Nom et téléphone */}
          <div className="form-row1">
            <div className="form-group1">
              <label>Nom *</label>
              <input
                type="text"
                name="nom"
                placeholder="Votre nom"
                value={formData.nom}
                onChange={handleChange}
              />
              {errors.nom && <p className="error">{errors.nom}</p>}
            </div>
            <div className="form-group1">
              <label>N° de téléphone *</label>
              <PhoneInput
                country={'tn'}
                value={formData.telephone}
                onChange={(value) =>
                  setFormData({ ...formData, telephone: value })
                }
                placeholder="N° téléphone *"
                inputStyle={{ width: '100%', height: '48px' }}
              />
              {errors.telephone && <p className="error">{errors.telephone}</p>}
            </div>
          </div>

          {/* Email et post occupé */}
          <div className="form-row1">
            <div className="form-group1">
              <label>Email *</label>
              <input
                type="email"
                name="email"
                placeholder="Votre email"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <p className="error">{errors.email}</p>}
            </div>
            <div className="form-group1">
              <label>Post Occupé *</label>
              <input
                type="text"
                name="postOccupe"
                placeholder="Votre Post Occupé"
                value={formData.postOccupe}
                onChange={handleChange}
              />
              {errors.postOccupe && (
                <p className="error">{errors.postOccupe}</p>
              )}
            </div>
          </div>

          {/* Employeur et pays */}
          <div className="form-row1">
            <div className="form-group1">
              <label>Employeur *</label>
              <input
                type="text"
                name="organisme"
                placeholder="Organisme/Employeur"
                value={formData.organisme}
                onChange={handleChange}
              />
              {errors.organisme && <p className="error">{errors.organisme}</p>}
            </div>
            <div className="form-group1">
              <label>Pays *</label>
              <select
                style={{ height: '48px' }}
                name="pays"
                value={formData.pays}
                onChange={handleChange}
              >
                <option value="">Sélectionnez votre pays</option>
                {countrie.map((c, index) => (
                  <option key={index} value={c}>
                    {c}
                  </option>
                ))}
              </select>
              {errors.pays && <p className="error">{errors.pays}</p>}
            </div>
          </div>

          {/* Mode formation et thème */}
          <div className="form-row1">
            <div className="form-group1">
              <label>Mode de formation *</label>
              <select
                name="modeFormation"
                value={formData.modeFormation}
                onChange={handleChange}
                style={{ height: '49px' }}
              >
                <option value="">Choisir un mode</option>
                <option value="En Présentiel">Présentiel</option>
                <option value="En ligne">En ligne</option>
              </select>
              {errors.modeFormation && (
                <p className="error">{errors.modeFormation}</p>
              )}
            </div>
            <div className="form-group1">
              <label>Thème *</label>
              <input
                type="text"
                name="theme"
                placeholder="Thème"
                value={formData.theme}
                onChange={handleChange}
              />
              {errors.theme && <p className="error">{errors.theme}</p>}
            </div>
          </div>

          {/* Date début et date fin */}
          <div className="form-row1">
            <div className="form-group1">
              <label>Date de début *</label>
              <input
                type="date"
                name="dateDebut"
                value={formData.dateDebut}
                onChange={handleChange}
              />
              {errors.dateDebut && <p className="error">{errors.dateDebut}</p>}
            </div>
            <div className="form-group1">
              <label>Date de fin *</label>
              <input
                type="date"
                name="dateFin"
                value={formData.dateFin}
                onChange={handleChange}
              />
              {errors.dateFin && <p className="error">{errors.dateFin}</p>}
            </div>
          </div>

          <div className="form-row1">
            <div className="form-group1">
              <label>Lieu *</label>
              <select
                name="lieu"
                value={formData.lieu}
                onChange={handleChange}
                style={{ height: '48px' }}
              >
                <option value="">Sélectionnez un lieu</option>
                <option value="Tunis - Tunisie">Tunis - Tunisie</option>
                <option value="Casablanca - Maroc">Casablanca - Maroc</option>
                <option value="Dubai - UAE">Dubai - UAE</option>
              </select>
              {errors.lieu && <p className="error">{errors.lieu}</p>}
            </div>
            <div className="form-group1">
              <label>Nombre de personnes *</label>
              <input
                type="text"
                name="nombrePersonnes"
                placeholder="Nombre de personnes"
                value={formData.nombrePersonnes}
                onChange={handleChange}
              />
              {errors.nombrePersonnes && (
                <p className="error">{errors.nombrePersonnes}</p>
              )}
            </div>
          </div>

          {/* Message */}
          <div className="form-row">
            <div className="col-12">
              <textarea
                rows="3"
                type="text"
                name="message"
                placeholder="Message"
                value={formData.message}
                onChange={handleChange}
                className="form-control"
              />
              {errors.message && <p className="error">{errors.message}</p>}
            </div>
          </div>

          {/* CAPTCHA */}
          <div
            id="recaptcha-container"
            style={{ marginTop: '20px', marginBottom: '10px' }}
          ></div>
          {errors.captcha && <p className="error">{errors.captcha}</p>}

          <div className="form-row">
            <div className="col-12">
              <center>
                <button type="submit">Demander Un Devis</button>
              </center>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default App;
